import { useRef } from "react";
import classnames from "classnames";
import { TooltipContainer } from "@outplayed/tooltips";
import DefaultSelect from "@ugg/shared/components/FilterManager/DefaultSelect";
import { useTranslation } from "react-i18next";
import { FILTER_IS_NOT_DEFAULT_CLASSNAME } from "@ugg/shared/components/FilterManager/FilterManager";
import { FilterSelect, FilterOption } from "@ugg/shared/interfaces/filter-manager.interface";

interface WatchGameProps {
  className?: string;
  currentGame: string;
  options: FilterOption[];
  disableByQueueType?: boolean;
  disableTooltip?: boolean;
  isMobile?: boolean;
  isDefault: boolean;
  onFilterChange: (filterType: string, filterOption: FilterOption | null) => void;
}

export default function WatchGameSwitcher(props: WatchGameProps) {
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });
  const { t } = useTranslation();
  const { className, isMobile, options, currentGame, isDefault, onFilterChange, disableTooltip } = props;

  const formatOptionLabel = ({ value, label, img }: (typeof options)[number]) => {
    return (
      <div className="flex items-center justify-normal text-left">
        <div className="w-[20px] h-[20px] flex justify-center items-center">{img}</div>
        <span style={{ marginLeft: "10px" }}>{t(label)}</span>
      </div>
    );
  };

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Game")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Game")}
          group={"game"}
          isMobile={isMobile}
          className={classnames("filter-select queue-type", {
            [FILTER_IS_NOT_DEFAULT_CLASSNAME]: isDefault,
          })}
          options={options}
          onChange={(selected: (typeof options)[number]) => {
            onFilterChange("game", selected);
          }}
          value={currentGame}
          formatOptionLabel={formatOptionLabel}
          width={183}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
}
